export default __webpack_public_path__ + "static/media/TherapistOff.1ff993b2.svg";